import { render } from "./TemplateLibraryDerivativeMaterials.vue?vue&type=template&id=7955d7cd"
import script from "./TemplateLibraryDerivativeMaterials.vue?vue&type=script&lang=js"
export * from "./TemplateLibraryDerivativeMaterials.vue?vue&type=script&lang=js"

import "./TemplateLibraryDerivativeMaterials.vue?vue&type=style&index=0&id=7955d7cd&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__